export interface Tomo {
  numero: number;
  titulo: string;
  subtitulo: string;
  bullets: string[];
  tiempo: string;
  kcal: string;
  colorBorder: string;
  colorTextDark: string;
  gradientFrom: string;
  imagenFondo?: string;
}

export const tomos: Tomo[] = [
  {
    numero: 1,
    titulo: 'Desayunos Antiinflamatorios',
    subtitulo: '35 recetas para arrancar el día con energía',
    bullets: [
      'Batidos desinflamantes con proteína',
      'Tortillas con verdura cruda',
      'Porridges digestivos sin gluten',
      'Huevos preparados 15 formas distintas',
      'Smoothie bowls bajos en azúcar'
    ],
    tiempo: '5-15 min',
    kcal: '300-450 kcal',
    colorBorder: '#10B981',
    colorTextDark: '#047857',
    gradientFrom: '#D1FAE5',
    imagenFondo: 'https://cdn.magicpatterns.com/uploads/jkzR65dnzLR16RgmDxYY56/ChatGPT_Image_11_sept_2026,_16_12_30.webp'
  },
  {
    numero: 2,
    titulo: 'Comidas Saciantes',
    subtitulo: '50 recetas que te dejan satisfecha y liviana',
    bullets: [
      'Fórmula ganadora: Proteína + Verdura + Grano',
      'Pescados a la plancha con verduras asadas',
      'Pollo marinado con guarniciones digestivas',
      'Ensaladas con proteína que sacian de verdad',
      'Bowls coloridos y antiinflamatorios'
    ],
    tiempo: '15-30 min',
    kcal: '450-600 kcal',
    colorBorder: '#FBBF24',
    colorTextDark: '#92400E',
    gradientFrom: '#FEF3C7',
    imagenFondo: 'https://cdn.magicpatterns.com/uploads/5VVbQNuPJnxxRsnew6koLC/ChatGPT_Image_11_sept_2026,_16_15_25.webp'
  },
  {
    numero: 3,
    titulo: 'Meriendas Antihinchazón',
    subtitulo: '35 recetas ligeras y saciantes',
    bullets: [
      'Snacks proteicos (no son galletas)',
      'Brochetas de fruta + proteína',
      'Hummus casero + verdura cruda',
      'Batidos proteicos sin azúcar',
      'Yogur natural + toppings inteligentes'
    ],
    tiempo: '2-5 min',
    kcal: '150-250 kcal',
    colorBorder: '#F97316',
    colorTextDark: '#C2410C',
    gradientFrom: '#FFECEB',
    imagenFondo: 'https://cdn.magicpatterns.com/uploads/nwb96MgN5qEmcCDAmVxWyj/ChatGPT_Image_11_sept_2026,_16_16_45.webp'
  },
  {
    numero: 4,
    titulo: 'Cenas Ligeras & Express',
    subtitulo: '50 recetas que no te mantienen despierta',
    bullets: [
      'Pescados al horno en papillote (5 ingredientes)',
      'Cremas de verdura digestivas',
      'Huevos preparados 10 formas distintas',
      'Marisco congelado en minutos',
      'Salmón + Verdura (combinación antiinflamatoria)'
    ],
    tiempo: '10-20 min',
    kcal: '350-500 kcal',
    colorBorder: '#3B82F6',
    colorTextDark: '#1E40AF',
    gradientFrom: '#DBEAFE',
    imagenFondo: 'https://cdn.magicpatterns.com/uploads/x24jME8sYexkc2xCZtHQmY/ChatGPT_Image_11_sept_2026,_16_18_53.webp'
  },
  {
    numero: 5,
    titulo: 'Postres Sin Culpa',
    subtitulo: '35 recetas dulces y antiinflamatorias',
    bullets: [
      'Mousse de chocolate antiinflamatorio',
      'Fruta + requesón (saciante de verdad)',
      'Flanes caseros con colágeno',
      'Sorbetes naturales sin azúcar',
      'Tartas sin gluten para ocasiones especiales'
    ],
    tiempo: '5-15 min',
    kcal: '120-200 kcal',
    colorBorder: '#EC4899',
    colorTextDark: '#BE185D',
    gradientFrom: '#FBCFE8',
    imagenFondo: 'https://cdn.magicpatterns.com/uploads/6iPbUeSQ5iLK1KkHbyPcWD/ChatGPT_Image_11_sept_2026,_16_19_43.webp'
  },
  {
    numero: 6,
    titulo: 'Cenas Express <10 Min',
    subtitulo: '40 recetas para cuando no tienes tiempo',
    bullets: [
      'Latas de sardinas/atún + combinaciones estratégicas',
      'Pollo rotisería + verdura cruda',
      'Marisco congelado exprés',
      'Montajes rápidos con máxima nutrición',
      'Soluciones para viajes y semanas caóticas'
    ],
    tiempo: '< 10 min',
    kcal: '300-450 kcal',
    colorBorder: '#F59E0B',
    colorTextDark: '#B45309',
    gradientFrom: '#FED7AA',
    imagenFondo: 'https://cdn.magicpatterns.com/uploads/5sG9uFggUnknaCjMkQoNQa/ChatGPT_Image_11_sept_2026,_16_21_37.webp'
  }
];
